import { getBomLineItemExtraData } from '../../utils/extracters';

import { NO_FOUND } from '../../data/BomLineItemStatus';

export const parseBomQuoteProgress = (state, bom_line_items) => {
  bom_line_items.forEach((bli) => {
    const { status, quote_status, selected_part } = bli;
    const bli_index = state.bom_line_items.findIndex((bp) => bp.id === bli.id);
    state.bom_line_items[bli_index].quote_status = bli.quote_status;
    if (bli.quote_status == 'processed') {
      state.bom_line_items[bli_index].status = {};
      state.bom_line_items[bli_index].qty_to_buy = {};
      state.bom_line_items[bli_index].price_by_qty = {};
      state.bom_line_items[bli_index].calculated_minimun_order_qty = {};
      if (status != NO_FOUND) {
        state.bom_line_items[bli_index].selected_part = selected_part;
        state.bom_line_items[bli_index].extra_parts = selected_part.extra_parts;
      }
      if (!state.bom_line_items[bli_index].extra_parts)
        state.bom_line_items[bli_index].extra_parts = {};
      state.board_qtys.map((board_qty) => {
        state.bom_line_items[bli_index].status[board_qty] = status;
        const {
          new_price_by_qty,
          new_qty_to_buy,
          new_status,
          error_message,
          markup,
          ps_selections_markups,
        } = getBomLineItemExtraData(
          state.bom_line_items[bli_index],
          board_qty,
          state.selected_board_qty,
        );
        state.bom_line_items[bli_index].status[board_qty] = new_status;
        state.bom_line_items[bli_index].error_message[board_qty] =
          error_message;
        state.bom_line_items[bli_index].qty_to_buy[board_qty] = new_qty_to_buy;
        state.bom_line_items[bli_index].calculated_minimun_order_qty[
          board_qty
        ] = new_qty_to_buy;
        if (ps_selections_markups && ps_selections_markups.length > 0) {
          ps_selections_markups.forEach((ps_markup, index) => {
            state.bom_line_items[bli_index].selected_part.ps_selections[
              board_qty
            ][index]['markup'] = ps_markup;
          });
        }
        if (markup > 0)
          state.bom_line_items[bli_index].selected_part.selected_part_supplier[
            board_qty
          ]['markup'] = markup;
        if (new_price_by_qty)
          state.bom_line_items[bli_index].price_by_qty[board_qty] =
            new_price_by_qty;
        if (
          board_qty === state.selected_board_qty &&
          (!error_message || error_message == '')
        )
          state.bom_line_items[bli_index].user_action = 'buy';
      });
    }
  });
};
